var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoWalmartDarkBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 152,
    height: 46,
    viewBox: "0 0 152 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Custom_Size_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 152,
    height: 46
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Custom_Size_1",
    "data-name": "Custom Size \\u2013 1",
    clipPath: "url(#clip-Custom_Size_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-walmart-navy-blue",
    transform: "translate(-0.192 4.495)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M88.374,19.5c0-3.655-1.565-6.884-6.856-6.884a12.487,12.487,0,0,0-6.04,1.451L76.335,17a8.912,8.912,0,0,1,4.415-1.232c2.679,0,3.118,1.512,3.118,2.486v.235c-5.847-.009-9.544,2.011-9.544,6.125a4.863,4.863,0,0,0,5.157,4.871,5.9,5.9,0,0,0,4.7-2.083h.1s.666,2.787,4.349,1.721a24.269,24.269,0,0,1-.257-3.891Zm-4.362,3.859a2.816,2.816,0,0,1-.112.865,3.054,3.054,0,0,1-2.944,2.068,2,2,0,0,1-2.177-2.138c0-2.213,2.444-2.822,5.233-2.807",
    transform: "translate(1.149 0.195)",
    fill: "#242e45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M0,7.718S3.819,23.344,4.427,25.875c.715,2.959,2,4.052,5.692,3.324l2.387-9.69c.6-2.4,1.014-4.122,1.4-6.568h.066a64.465,64.465,0,0,0,1.154,6.576s.974,4.4,1.479,6.708,1.877,3.761,5.5,2.974L27.8,7.718H23.208l-1.95,9.292c-.516,2.692-.986,4.813-1.351,7.279h-.066c-.329-2.44-.747-4.474-1.284-7.111l-2.02-9.461H11.75L9.593,16.937C8.978,19.752,8.4,22.009,8.042,24.4H7.979c-.373-2.242-.878-5.1-1.413-7.805,0,0-1.281-6.6-1.733-8.874",
    transform: "translate(0 0.119)",
    fill: "#242e45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M40.176,19.5c0-3.655-1.568-6.884-6.86-6.884a12.493,12.493,0,0,0-6.036,1.451L28.137,17a8.883,8.883,0,0,1,4.415-1.232c2.679,0,3.118,1.512,3.118,2.486v.235c-5.847-.009-9.548,2.011-9.548,6.125a4.865,4.865,0,0,0,5.149,4.871A5.885,5.885,0,0,0,35.978,27.4h.1s.67,2.787,4.349,1.721a24.089,24.089,0,0,1-.253-3.891V19.5ZM35.81,23.359a2.937,2.937,0,0,1-.108.865,3.064,3.064,0,0,1-2.951,2.068,2,2,0,0,1-2.174-2.138c0-2.213,2.444-2.822,5.233-2.807",
    transform: "translate(0.404 0.195)",
    fill: "#242e45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M42.307,7.718V29.192h4.366V7.718Z",
    transform: "translate(0.654 0.119)",
    fill: "#242e45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M101.357,7.718V23.562c0,2.187.41,3.712,1.294,4.646a4.864,4.864,0,0,0,3.556,1.353,10.577,10.577,0,0,0,3.167-.467l-.053-3.411a7,7,0,0,1-1.665.193c-1.491,0-1.982-.944-1.982-2.908V16.9h3.8V12.8h-3.8V7.718",
    transform: "translate(1.567 0.119)",
    fill: "#242e45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M90.243,12.988V29.123h4.514V20.86a6.094,6.094,0,0,1,.1-1.184,3.4,3.4,0,0,1,3.564-2.845,7.552,7.552,0,0,1,1.294.121v-4.23a4.632,4.632,0,0,0-5.392,3.316H94.21V12.988",
    transform: "translate(1.395 0.195)",
    fill: "#242e45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M49.1,12.988V29.123h4.4v-9.47a3.679,3.679,0,0,1,.206-1.309,2.951,2.951,0,0,1,2.669-2.07c1.771,0,2.607,1.494,2.607,3.651v9.2h4.387V19.539a4.512,4.512,0,0,1,.182-1.3,2.752,2.752,0,0,1,2.641-1.964c1.79,0,2.656,1.462,2.656,4v8.844h4.383V19.609c0-5-2.542-6.981-5.429-6.981a5.837,5.837,0,0,0-3.188.872,6.911,6.911,0,0,0-2.045,2H62.5a4.6,4.6,0,0,0-4.455-2.875,5.073,5.073,0,0,0-4.7,2.544H53.28V12.988",
    transform: "translate(0.759 0.195)",
    fill: "#242e45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M132.654,12.459a1.6,1.6,0,0,0,1.684-1.029l.855-9.686c0-.959-1.13-1.744-2.539-1.744s-2.539.785-2.539,1.744l.863,9.686a1.585,1.585,0,0,0,1.676,1.029",
    transform: "translate(2.011 0)",
    fill: "#242e45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M127.62,15.372a1.589,1.589,0,0,0-.059-1.971l-7.983-5.583c-.83-.484-2.073.093-2.785,1.315s-.566,2.59.248,3.065l8.838,4.1a1.581,1.581,0,0,0,1.74-.931",
    transform: "translate(1.798 0.118)",
    fill: "#242e45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M137.784,15.364a1.625,1.625,0,0,0,1.742.942l8.838-4.109c.821-.484.944-1.841.25-3.061-.709-1.222-1.96-1.8-2.788-1.32l-7.985,5.577a1.629,1.629,0,0,0-.047,1.979",
    transform: "translate(2.125 0.118)",
    fill: "#242e45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M132.654,24.184a1.6,1.6,0,0,1,1.684,1.029l.855,9.686c0,.959-1.129,1.737-2.539,1.737s-2.539-.778-2.539-1.737l.863-9.686a1.585,1.585,0,0,1,1.676-1.029",
    transform: "translate(2.011 0.374)",
    fill: "#242e45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M137.784,21.223c.452-.751,1.192-1.152,1.742-.935l8.838,4.1c.821.475.944,1.843.25,3.065-.709,1.213-1.96,1.79-2.788,1.315l-7.985-5.584a1.6,1.6,0,0,1-.047-1.962",
    transform: "translate(2.125 0.313)",
    fill: "#242e45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M127.62,21.214a1.589,1.589,0,0,1-.059,1.971l-7.983,5.575c-.83.484-2.073-.095-2.785-1.307s-.566-2.59.248-3.065l8.838-4.1a1.577,1.577,0,0,1,1.74.927",
    transform: "translate(1.798 0.313)",
    fill: "#242e45"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWalmartDarkBlue);
export default __webpack_public_path__ + "static/media/logo-walmart-dark-blue.913608e1f348df8ca1a6441e4a4ddddf.svg";
export { ForwardRef as ReactComponent };